import React, { Component, useEffect } from 'react';
import { Helmet } from "react-helmet";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation
} from 'react-router-dom';

import { Home } from './Home';
import About from './About';
import Contact from './Contact';
import { NavigationBar } from './components/NavigationBar';
import Navigationdowen from './components/Navigationdowen';
import Screen from './components/Screen';
import Slider from './components/Slider/Slider';
import styled from "styled-components";
import CookieConsent from './CookieConsent';
import AccessibilityWidget from "./AccessibilityWidget";
import WhatsAppBot from "./WhatsAppBot";
////import Adsense from "./Adsense";

import './App.css';


const Styleapp = styled.div`
  background-color: #081a2f;
  min-height: 100vh;
  width: 100%;
`;


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};


class App extends Component {

  seo = {
    title: "SITE B2B | בניית אתרים לעסקים שמביאים לקוחות",

    description:
      "בניית אתרי אינטרנט מקצועיים עם דגש על קידום בגוגל, מהירות גבוהה ועיצוב שממיר לקוחות בפועל.",

    keywords:
      "בניית אתרים לעסקים, קידום אתרים, אתר שמביא לקוחות, עיצוב אתרים מקצועי",

    url: "https://siteb2b.co.il/",

    image: "https://siteb2b.co.il/logo1922.png",
  };


  render() {

    return (

      <Styleapp className="App">

        <Router>

          <ScrollToTop />

          <Helmet>

            <title>{this.seo.title}</title>

            <meta
              name="description"
              content={this.seo.description}
            />

            <meta
              name="keywords"
              content={this.seo.keywords}
            />

            <meta property="og:title" content={this.seo.title} />

            <meta property="og:description" content={this.seo.description} />

            <meta property="og:image" content={this.seo.image} />

            <meta property="og:url" content={this.seo.url} />

            <meta property="og:type" content="website" />

          </Helmet>


          <AccessibilityWidget />


          <div id="site-content">

            <NavigationBar />

            <Screen />

            <CookieConsent />

            <WhatsAppBot />


            <Switch>

              <Route exact path="/" component={Home} />

              <Route path="/Mysite" component={Slider} />

              <Route path="/About" component={About} />

              <Route path="/Contact" component={Contact} />

            </Switch>


            <Navigationdowen />


          </div>

        </Router>

      </Styleapp>

    );

  }

}


export default App;
